'use client';

import React from 'react';
import { Menu } from '@miso/design-system';
import { LightModeIcon, DarkModeIcon, PaletteIcon } from '@/shared/ui/display/EmojiIcon';
import { useAppTheme } from '@/shared/theme';

/**
 * 테마 전환 서브메뉴 — `<Menu.SubMenu>` 형태.
 * Fab 또는 Menu 내부에서 사용한다.
 */
export function ThemeSwitcherSubMenu() {
  const { mode, setTheme } = useAppTheme();

  return (
    <Menu.SubMenu icon={<PaletteIcon fontSize="small" />} label="테마 전환">
      <Menu.Item
        icon={<LightModeIcon fontSize="small" />}
        selected={mode === 'light'}
        onClick={() => setTheme('light')}
      >
        라이트 모드
      </Menu.Item>
      <Menu.Item
        icon={<DarkModeIcon fontSize="small" />}
        selected={mode === 'dark'}
        onClick={() => setTheme('dark')}
      >
        다크 모드
      </Menu.Item>
    </Menu.SubMenu>
  );
}
